import { render, staticRenderFns } from "./authorize.vue?vue&type=template&id=0a396261&scoped=true&"
import script from "./authorize.vue?vue&type=script&lang=js&"
export * from "./authorize.vue?vue&type=script&lang=js&"
import style0 from "./authorize.vue?vue&type=style&index=0&id=0a396261&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a396261",
  null
  
)

export default component.exports